import type { CodeProjectMeta } from '@repo/project-interface';
import { splitProjectFile } from '../util/project-file-util';

/**
 * 프로젝트 파일을 deserialize 합니다.
 * meta와 data를 리턴합니다.
 */
export async function deserializeProject<TProjectData>(
  pjtFileBlob: Blob,
  unzip: (zipBlob: Blob) => Promise<TProjectData>,
): Promise<{ meta: CodeProjectMeta; data: TProjectData }> {
  const fileBytes = new Uint8Array(await pjtFileBlob.arrayBuffer());
  const { header, zipFile } = await splitProjectFile(fileBytes);
  const data = await unzip(zipFile);
  return {
    meta: header, // 현재는 ProjectHeader와 CodeProjectMeta가 동일함
    data,
  };
}
